import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    clickTab: 0, //车务助手服务团队tab栏切换
    keepAlive: [], //保存缓存页面的name属性
    listIsScroll: true, //list页面是否需要滚动
    dateTab: 0, //0 今日 1 明日 2超期
    orderType: [], //业务类型集合(保存业务类型id)
    personType: '', //人员类型
    fileList:[],//文件明细
    orderTypename:[],
    ActualDealPerson:null,
    TimeFlag:0,
    mortgagee:null,
    DealType:{}
  },
  mutations: {
    //设置状态
    setClickTab (state, clickTab) {
      state.clickTab = clickTab;
    },
    setTimeFlag (state, TimeFlag) {
      state.TimeFlag = TimeFlag;
    },
    
    setKeepAlive: (state, keepAlive) => {
      state.keepAlive = keepAlive;
    },
    setListIsScroll: (state, listIsScroll) => {
      state.listIsScroll = listIsScroll;
    },
    setDateTab: (state, dateTab) => {
      state.dateTab = dateTab;
    },
    setIsPledgeClick: (state, isPledgeClick) => {
      state.isPledgeClick = isPledgeClick;
    },
    setOrderType: (state, orderType) => {
      if (Array.isArray(orderType)) {
        state.orderType = orderType;
      } else {
        state.orderType = [orderType];
      }
    },
    setActualDealPerson:(state, ActualDealPerson) => { 
        state.ActualDealPerson = ActualDealPerson;   
     
    },
    setActualmortgagee:(state, mortgagee) => { 
      state.mortgagee = mortgagee;    
    },
    setOrderTypename:(state, orderTypename) => {
      if (Array.isArray(orderTypename)){
        state.orderTypename = orderTypename;
      } else {
        state.orderTypename = [orderTypename];    
    }},
    setPersonType (state, personType) {
      state.personType = personType;
    },
    setDealType (state,DealType){
      state.DealType = DealType
      console.log(66,state.DealType);
    },
    //清空状态
    clearClickTab (state) {
      state.clickTab = 0;
    },
    clearKeepAlive: (state) => {
      state.keepAlive = [];
    },
    clearListIsScroll: (state) => {
      state.listIsScroll = true;
    },
    clearDateTab: (state) => {
      state.dateTab = 0;
    },
    clearOrderType: (state) => {
      state.orderType = [];
    },
    clearOrderTypename: (state) => {
      state.orderTypename = [];
    },
    setFile (state, fileList) {
      state.fileList = state.fileList.concat(fileList);
    },
    setList(state, arry) {
      state.fileList = []
    },

  },
  getters: {
    keepAlive: state => state.keepAlive,
    clickTab: state => state.clickTab,
    DealType: state => state.DealType,
    listIsScroll: state => state.listIsScroll,
    dateTab: state => state.dateTab,
    orderType: state => state.orderType,
    isNotCharge: state => !state.personType ? true : (state.personType == 1 || state.personType == 5) ? false : true//人员类型是否不为经理/总监(1/5)
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js